import { NgClass } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
// import { EventService } from "app/modules/events/services/event.service";
import * as _ from 'lodash';
import { MenuItem } from "primeng/api";
import { SkeletonModule } from "primeng/skeleton";
import { ToastModule } from "primeng/toast";
// import { FullScreenService } from "../../../dashboard/services/full-screen-service";
import { AppIcons } from "../../app.icons";
import { AppSettings } from "../../app.settings";
import { Country } from "../../models/country";
import { Language } from "../../models/language";
import { CommonBindingDataService } from "../../services/common-binding-data.service";
import { ConfigService } from "../../services/config.service";
import { EntityService } from "../../services/entity.service";
import { GoogleMapsService } from "../../services/google-map.services";
import { MetaDataService } from "../../services/meta-data.service";
import { RestApiService } from "../../services/rest-api.service";
import { UserCommonService } from "../../services/user-common.service";
import { HeaderComponent } from "../header/header.component";
import { LoaderComponent } from "../loader/loader.component";
import { LoaderService } from "../loader/loader.service";
import { SidebarComponent } from "../sidebar/sidebar.component";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
  standalone: true,
  imports: [
    LoaderComponent,
    ToastModule,
    NgClass,
    SidebarComponent,
    HeaderComponent,
    RouterOutlet,
    SkeletonModule
  ],
})
export class LayoutComponent implements OnInit {
  miIcons = AppIcons;
  isSidebarFull: boolean = false;
  metaData: Country;
  languageDetails: Language;
  isFullScreen: boolean = false;
  isSidebarReady: boolean = false;
  isMapLoaded: boolean = false;
  items: MenuItem[] = [];
  eventResponse;
  entityId;
  logo: any = "../../../../../../assets/images/mi-theme/light/logo/akesa200.svg";
  isOnline: boolean = false;
  languageCountryPayload = {
    "limit": 20,
    "offset": 0
  }
  entityData: any = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    defaultSortColumn: 'updatedAt',
    defaultSortType: 'asc',
    status: 'Both',
    startDate: 1704067200000,
    endDate: 0
  };

  eventListRequestBody = {
    forTenantCode: this.configService.getForTenantCode(),
    status: 'active'
  }

  appConfigPayload = {
    limit: 0,
    offset: 0,
    searchStr: "WEB",
    filters: [

    ],
    forTenantCode: this.configService.getForTenantCode(),
    countryCode: "IN",
    eventCode: "1",
    deleted: "only_non_deleted",
    tableViewCode: AppSettings.VIEW_CODE.ADD_EDIT_VIEW,
    advanceFilters: [
    ]
  }

  private onlineListener: () => void;
  private offlineListener: () => void;
  private networkCheckInterval: any;

  constructor(
    private commonService: CommonBindingDataService,
    // private fullScreenService: FullScreenService,
    private googleMapsService: GoogleMapsService,
    private configService: ConfigService,
    private restApiService: RestApiService,
    private metaDataService: MetaDataService,
    private entityService: EntityService,
    // private eventService: EventService,
    private router: Router,
    private loaderService: LoaderService,
    private userCommonService: UserCommonService
  ) { }

  ngOnInit() {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData) {
      this.router.navigate(['/auth/login']);
      return;
    }
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.getGeneralSettings();

    // this.fullScreenService.isFullScreen$.subscribe((isFullScreen) => {
    // this.isFullScreen = isFullScreen;
    // });
  }

  isReadySidebar(event) {
    this.isSidebarReady = event;
  }

  getMetaData() {
    const payload = this.getMultiApiPayload();
    this.loaderService.hide();

    // this.userCommonService.signOut().subscribe(res => {
    //   console.log(res);
    // });
    this.metaDataService.metaDataMultipleApi(payload).subscribe((res) => {
      const setCountry = JSON.parse(res.setCountry.responseBody);
      localStorage.setItem(AppSettings.COUNTRY, JSON.stringify(setCountry.data));
      this.metaData = setCountry;
      const setLanguage = JSON.parse(res.setLanguage.responseBody);
      localStorage.setItem(AppSettings.LANGUAGE, JSON.stringify(setLanguage.data));
      this.languageDetails = setLanguage;

      const menus = JSON.parse(res.menus.responseBody);
      this.items = _.sortBy(menus, (menu) => parseInt(menu.orderIndex));
      this.items = _.sortBy(this.items, (menu) => parseInt(menu.orderIndex));
      // const setEvent = JSON.parse(res.setEvent.responseBody);
      // this.eventResponse = setEvent;
      // const generalSettings = JSON.parse(res.generalSettings.responseBody);
      // const generalSettingsData = this.commonService.getOrgAttributeValues(generalSettings);

      // if (setEvent?.length > 0) {
      this.metaDataService.updateMetaData(setCountry, setLanguage, menus); //setEvent, generalSettingsData
      //   this.metaDataService.countrySubject.next(setCountry);
      //   this.metaDataService.languageSubject.next(setLanguage);
      //   this.metaDataService.menusSubject.next(menus);
      //   this.metaDataService.eventResponseSubject.next(setEvent);
      //   this.metaDataService.generalSettingsSubject.next(generalSettingsData);

      //   this.appConfigPayload.countryCode = setCountry.data[0].countryCode;
      //   this.metaDataService.appConfig(AppSettings.ENTITY_CODE.APP_CONFIG, this.appConfigPayload).subscribe(res => {
      //     const values = res?.data?.[0]?.values?.web_idle_time_session_logout;
      //     if (values) {
      //       sessionStorage.setItem('idleTimeSession', JSON.stringify(values));
      //     }
      //     if (res?.data?.[0]?.values?.google_web_key) {
      //       const googleApiKey = res.data[0].values.google_web_key;
      //       const mapId = res.data[0].values.web_google_map_id;
      //       this.googleMapsService.loadScript(googleApiKey, mapId).then((res) => {
      //         this.isMapLoaded = true;

      //       }).catch(error => {
      //         console.error('Failed to load Google Maps:', error);
      //       });
      //     }
      //   });
      // }
    });
  }

  getGeneralSettings() {
    // this.entityService.getEntityDetailsByView(AppSettings.ENTITY_TYPE.GENERAL_SETTINGS, {}, false).subscribe({
    //   next: (response: any) => {
    //     this.entityId = response.entityId;
    this.getMetaData();
    //   },
    //   error: () => {
    //     this.router.navigate(["/auth/login"]);
    //   }
    // });
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/countries/search?forTenantCode=${this.configService.getForTenantCode()}`,
        inputBody: this.languageCountryPayload,
        method: 'POST',
        outputKey: AppSettings.META_OUTPUT_KEY.SET_COUNTRY,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/languages/search?forTenantCode=${this.configService.getForTenantCode()}`,
        inputBody: this.languageCountryPayload,
        method: 'POST',
        outputKey: AppSettings.META_OUTPUT_KEY.SET_LANGUAGE,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      // {
      //   url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/events/user-events`,
      //   inputBody: this.eventListRequestBody,
      //   method: 'POST',
      //   outputKey: AppSettings.META_OUTPUT_KEY.SET_EVENT,
      //   headers: this.restApiService.getHeaderForMultipleAPI()
      // },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getStaticTenantCode()}/api/v1/menus?forTenantCode=${this.configService.getForTenantCode()}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.MENUS,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      // {
      //   // url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_TYPE.GENERAL_SETTINGS}/entities/${this.entityId}?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADD_EDIT_VIEW}&eventCode=${this.eventService.getSelectedEventcode()}`,
      //   inputBody: '',
      //   method: 'GET',
      //   outputKey: AppSettings.META_OUTPUT_KEY.GENERAL_SETTINGS,
      //   headers: this.restApiService.getHeaderForMultipleAPI()
      // }
    ]
  }
}
